import { apiGet, apiPost } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getTvSettingsAPI = () => {
  return apiGet('plugins/settings/tv')
}

export const saveTvSettingsAPI = (data) => {
  Hotjar.event('save_tv_settings')
  return apiPost('plugins/settings/tv', data)
}



// WEBPACK FOOTER //
// ./src/api/tvSettings.js